/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Statistic from 'admin/components/Statistic.jsx';

import './styles/SchoolStatistics.scss';

type Props = {
  organizationId: number,
  data: {
    loading: boolean,
    organizations?: [{
      statistics: {
        teacher_count: number,
        student_count: number,
        parent_count: number,
        message_count: number,
      },
    }]
  }
}

function SchoolStatistics(props: Props) {
  const { loading, organizations } = props.data;

  if (loading || !organizations) {
    return null;
  }

  const { statistics } = organizations[0];

  return (
    <div className="SchoolStatistics">
      <Statistic name="Teachers" value={statistics.teacher_count} />
      <Statistic name="Parents" value={statistics.parent_count} />
      <Statistic name="Students" value={statistics.student_count} />
      <Statistic name="Announcements" value={statistics.message_count} />
    </div>
  );
}


const withOrganizationStatistics = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      statistics {
        teacher_count
        student_count
        parent_count
        message_count
      }
    }
  }
  `,
  {
    options: ({ organizationId }) => ({
      variables: { organizationId: [organizationId] },
    }),
  }
);

export { SchoolStatistics };
export default withOrganizationStatistics(SchoolStatistics);



// WEBPACK FOOTER //
// ./src/admin/components/SchoolStatistics.jsx